import { Row, Col, Accordion } from "react-bootstrap"
import { models } from "../../../../utils"
import Link from "../../../Base/link"
import { Modal } from "../../../Modal"
import * as S from "./styled"
import {
  item as text,
  prismItem as prismText,
  coloringItem as coloringText,
  progressive as progressiveText,
  customMeasurements as customMeasurementsText,
} from "../../../../i18n/pt.json"
import { mountRedirect } from "../../../../utils/redirect.service"

export const Collapse = ({ details, enable }) => (
  <Accordion.Collapse style={{ transition: "all 500ms" }} in={enable} eventKey="0">
    <div data-testid="collapseSurfacadoValues">
      <S.CollapseTitle>
        <Col>{text.meansures}</Col>
        <Col>{text.dnp}</Col>
        <Col>{text.height}</Col>
        <Col>{text.meansures}</Col>
        <Col>{text.dnp}</Col>
        <Col>{text.height}</Col>
      </S.CollapseTitle>
      <S.CollapseRow>
        <Col>
          <i>{text.rightEye}</i>
        </Col>
        <Col>{details.DIR_DNP}</Col>
        <Col>{details.DIR_ALTURA}</Col>
        <Col>
          <i>{text.leftEye}</i>
        </Col>
        <Col>{details.ESQ_DNP}</Col>
        <Col>{details.ESQ_ALTURA}</Col>
      </S.CollapseRow>

      {Boolean(details.DISTANCIA_DE_TRABALHO) && (
        <div>
          <S.CollapseTitle>
            <Col>Distância de Trabalho</Col>
          </S.CollapseTitle>
          <S.CollapseRow>
            <Col>
              Valor
              <br />
              {details.DISTANCIA_DE_TRABALHO}
            </Col>
          </S.CollapseRow>
        </div>
      )}

      {Boolean(details.ALTURA_CORREDOR > 0) && (
        <div>
          <S.CollapseTitle>
            <Col>{progressiveText.title}</Col>
          </S.CollapseTitle>
          <S.CollapseRow style={{ display: "inline-flex", width: "25%" }}>
            <Col>
              {progressiveText.value}
              <br />
              {details.ALTURA_CORREDOR}
            </Col>
          </S.CollapseRow>
        </div>
      )}

      <S.CollapseTitle>
        <Col>{text.frameData}</Col>
      </S.CollapseTitle>
      <S.CollapseRow>
        <Col>
          {text.width}
          <br />
          {details.LARARM}
        </Col>
        <Col>
          {text.height}
          <br />
          {details.ALTARM}
        </Col>
        <Col>
          {text.bridge}
          <br />
          {details.PONTARM}
        </Col>
        <Col>
          {text.rimType}
          <br />
          {details.ZHC_MATERI}
        </Col>
        <Col>
          {text.material}
          <br />
          {details.ZHC_CODMAN}
        </Col>
        <Col style={{ alignItems: "right" }}>
          <img
            alt={`len${details.MODELO}`}
            src={`https://www.haytek.com.br/assets/images/modelos/${models[details.MODELO]}.jpg`}
            style={{ width: "97px" }}
          />
        </Col>
        <Col>{text.approximateModel}</Col>
      </S.CollapseRow>

      {Boolean(details.MEDIDAS_PERSONALIZADAS) && (
        <div>
          <S.CollapseTitle>
            <Col>{customMeasurementsText.title}</Col>
          </S.CollapseTitle>
          <S.CollapseRow>
            <Col>
              {customMeasurementsText.vertexDistance}
              <br />
              {details.DISTANCIA_VERTICE}
            </Col>
            <Col>
              {customMeasurementsText.frameAngle}
              <br />
              {details.ANGULO_DA_ARMACAO}
            </Col>
            <Col>
              {customMeasurementsText.pantoscopicAngle}
              <br />
              {details.ANGULO_PANTOSCOPICO}
            </Col>
          </S.CollapseRow>
        </div>
      )}

      {Boolean(details.Corte_montagem) && (
        <div>
          <S.CollapseTitle>
            <Col>Montagem</Col>
          </S.CollapseTitle>
          <S.CollapseRow>
            <Col>
              {text.model}
              <br />
              {details.ZHC_MODELO}
            </Col>
            <Col>
              {text.color}
              <br />
              {details.ZHC_COLOR}
            </Col>
            <Col>
              {text.brand}
              <br />
              {details.ZHC_MARCA}
            </Col>
          </S.CollapseRow>
        </div>
      )}

      {Boolean(details.Tracagem_remota) && (
        <div>
          <S.CollapseTitle>
            <Col>Corte Remoto</Col>
          </S.CollapseTitle>
          <S.CollapseRow>
            <Col>
              {text.file}
              <br />
              <i>{details.URL_Tracagem}</i>
            </Col>
          </S.CollapseRow>
        </div>
      )}

      {Boolean(details.DADOSPRISMA) && (
        <div data-testid="prisma">
          <S.CollapseTitle>
            <Col>{prismText.titleFlat}</Col>
          </S.CollapseTitle>
          <Row className="mb-2 mt-1">
            <Col>
              {text.item}
              <br />
              <i>{text.rightEye}</i>
            </Col>
            <Col>
              {prismText.prism}
              <br />
              {details.DIR_PRIS_HORIZ}
            </Col>
            <Col>
              {prismText.prismBase}
              <br />
              {details.DIR_PRIS_BASEHORIZ}
            </Col>
            <Col>
              {text.item}
              <br />
              <i>{text.leftEye}</i>
            </Col>
            <Col>
              {prismText.prism}
              <br />
              {details.ESQ_PRIS_HORIZ}
            </Col>
            <Col>
              {prismText.prismBase}
              <br />
              {details.ESQ_PRIS_BASEHORIZ}
            </Col>
          </Row>

          <S.CollapseTitle>
            <Col>{prismText.titleVertical}</Col>
          </S.CollapseTitle>
          <S.CollapseRow>
            <Col>
              {text.item}
              <br />
              <i>{text.rightEye}</i>
            </Col>
            <Col>
              {prismText.prism}
              <br />
              {details.DIR_PRIS_VERT}
            </Col>
            <Col>
              {prismText.prismBase}
              <br />
              {details.DIR_PRIS_BASEVERT}
            </Col>
            <Col>
              {text.item}
              <br />
              <i>{text.leftEye}</i>
            </Col>
            <Col>
              {prismText.prism}
              <br />
              {details.ESQ_PRIS_VERT}
            </Col>
            <Col>
              {prismText.prismBase}
              <br />
              {details.ESQ_PRIS_BASEVERT}
            </Col>
          </S.CollapseRow>
        </div>
      )}

      {Boolean(details.COLORACAO) && (
        <div>
          <S.CollapseTitle>
            <Col>{coloringText.title}</Col>
          </S.CollapseTitle>
          <S.CollapseRow style={{ display: "inline-flex", width: "25%" }}>
            <Col>
              {coloringText.hue}
              <br />
              {coloringText.colors[details.COD_TONALIDADE]}
              <img
                src={`https://repositorio.lenteshaytek.com.br/coloracao/${details.COD_TONALIDADE}.png`}
                width={30}
                style={{ marginLeft: 5 }}
                alt="color example"
              />
            </Col>
            <Col>
              {coloringText.intensity}
              <br />
              {coloringText.intensities[details.COD_INTENSIDADE]}
              <img
                src={`https://repositorio.lenteshaytek.com.br/coloracao/${details.COD_TONALIDADE}-${details.COD_INTENSIDADE}.png`}
                width={30}
                style={{ marginLeft: 5 }}
                alt="intensity example"
              />
            </Col>
          </S.CollapseRow>
        </div>
      )}
    </div>
  </Accordion.Collapse>
)

export const Header = () => {
  const { header } = text

  return (
    <S.Header className="d-flex w-100">
      <Col xs={2}>
        <S.TextHeader>{header.product}</S.TextHeader>
      </Col>
      <Col xs={1}>
        <S.TextHeader>{text.item}</S.TextHeader>
      </Col>
      <Col xs={2} className="d-block d-lg-none">
        <S.TextHeader>{header.esf}</S.TextHeader>
      </Col>
      <Col xs={2} className="d-none d-lg-block">
        <S.TextHeader>{header.spherical}</S.TextHeader>
      </Col>
      <Col xs={2} className="d-block d-lg-none">
        <S.TextHeader>{header.cil}</S.TextHeader>
      </Col>
      <Col xs={2} className="d-none d-lg-block">
        <S.TextHeader>{header.cylindrical}</S.TextHeader>
      </Col>
      <Col xs={2} lg={1}>
        <S.TextHeader>{header.axle}</S.TextHeader>
      </Col>
      <Col xs={2} lg={2}>
        <S.TextHeader>{header.add}</S.TextHeader>
      </Col>
      <Col xs={2} />
    </S.Header>
  )
}

export const Layout = ({ item, editRoute, details, handleDelete, collapse, toggleCollapse }) => (
  <Accordion>
    <S.Description>
      <Row style={{ lineHeight: "2.5rem" }}>
        <Col xs={2} lg={2}>
          <Link action={editRoute}>
            <S.Lente url={item.lente} />
          </Link>
        </Col>
        <Col xs={1} lg={1}>
          <i>{text.rightEye}</i>
          <br />
          <i>{text.leftEye}</i>
        </Col>
        <Col xs={2} lg={2}>
          {item.DIR_ESFER}
          <br />
          {item.ESQ_ESFER}
        </Col>
        <Col xs={2} lg={2}>
          {item.DIR_CIL}
          <br />
          {item.ESQ_CIL}
        </Col>
        <Col xs={2} lg={1}>
          {item.DIR_EIXO}
          <br />
          {item.ESQ_EIXO}
        </Col>
        <Col xs={2} lg={2}>
          {item.DIR_ADD}
          <br />
          {item.ESQ_ADD}
        </Col>
        <Col xs={4} lg={2} className="d-flex justify-content-center">
          <S.IconEdit
            data-testid="editRedirectSurfacado"
            item={item.itemID}
            onClick={mountRedirect(editRoute)}
          />
          <Modal deleteModal fn={handleDelete} />
        </Col>
      </Row>
    </S.Description>

    <S.Details>
      <Row noGutters className="mb-3  d-flex">
        <Col xs={2} lg={4}>
          <div className="d-lg-block">OS: {item.OSCLI}</div>
          <div className="d-lg-block">
            {text.productName} {item.nome}
          </div>
          <div className="d-lg-block">Nome da ótica: {item.opticsName}</div>
        </Col>
        <Col xs={6} lg={4} className="text-center d-lg-block">
          <S.ShowDetails data-testid="openCollapseSurfacado" onClick={toggleCollapse}>
            {text.viewDetails}&nbsp;&nbsp;
            <img src="/images/montagem.png" alt="montagem" />
          </S.ShowDetails>
        </Col>
        <Col xs={4} lg={4} className="text-right">
          {text.lensValue}
          {item.price}
          <br />
          {Boolean(item.mounting || item.coloring) && (
            <span data-testid="surfacadoService">
              {text.serviceValue}
              {item.service}
            </span>
          )}
        </Col>
      </Row>

      <Collapse details={details} enable={collapse} />
    </S.Details>
  </Accordion>
)
